import React, { Fragment } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import { Button } from 'components/button';
import { Modal } from 'components/cosmos/v2/modal';
import { useTranslation } from 'configs/translationContext';
import PropTypes from 'prop-types';

import styles from './playerModal.module.scss';

const PlayerActiveInfoModal = ({
  isOpen,
  onConfirm,
  onClose,
  streamingCosts
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      title="player_modal.title"
      show={isOpen}
      onClose={() => onClose()}
      className={styles.playerModal}
    >
      <Modal.Header className={styles.playerModalHeader}>
        <h2 className="_text-4 _text-lg-4 _font-weight-light _mb-0">
          {t('player_active_info_modal_v2.title')}
        </h2>
      </Modal.Header>

      <Modal.Body className={classNames(styles.playerModalBody, '_mb-2')}>
        <div>
          <li className="_text-2 _mb-3">
            {t('player_active_info_modal_v2.description')}
          </li>

          <div
            className={classNames(styles.advantagesContainer, '_text-2 _mb-4')}
          >
            <li
              className={classNames(
                styles.advantage,
                '_d-flex _gap-2 _align-items-center'
              )}
            >
              <FontAwesomeIcon icon={['fas', 'square-check']} />
              {t('player_modal_v2.advantage_1')}
            </li>
            <li
              className={classNames(
                styles.advantage,
                '_d-flex _gap-2 _align-items-center'
              )}
            >
              <FontAwesomeIcon icon={['fas', 'square-check']} />
              {t('player_modal_v2.advantage_2')}
            </li>
            <li
              className={classNames(
                styles.advantage,
                '_d-flex _gap-2 _align-items-center'
              )}
            >
              <FontAwesomeIcon icon={['fas', 'square-check']} />
              {t('player_modal_v2.advantage_3')}
            </li>
            <li
              className={classNames(
                styles.advantage,
                '_d-flex _gap-2 _align-items-center'
              )}
            >
              <FontAwesomeIcon icon={['fas', 'square-check']} />
              {t('player_modal_v2.advantage_4')}
            </li>
            <li
              className={classNames(
                styles.advantage,
                '_d-flex _gap-2 _align-items-center'
              )}
            >
              <FontAwesomeIcon icon={['fas', 'square-check']} />
              {t('player_modal_v2.advantage_5')}
            </li>
            <li className={classNames(styles.billingInfo, '_text-1')}>
              {t('player_modal_v2.info', {
                data: {
                  value: streamingCosts.addOnCost,
                  value2: streamingCosts.bundleAddOnCost
                }
              })}
            </li>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="_d-flex _justify-content-end">
        <Fragment>
          <Button
            size="small"
            onClick={() => onConfirm()}
            className="hot-button hot-button--primary"
          >
            {t('general.ok')}
          </Button>
        </Fragment>
      </Modal.Footer>
    </Modal>
  );
};

PlayerActiveInfoModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onConfirm: PropTypes.func.isRequired,
  streamingCosts: PropTypes.object.isRequired
};

export default PlayerActiveInfoModal;
